import React, { useEffect, useState } from 'react';

import SatSelect from '@components/common/satUI/SatSelect';

const OldWithdrawalStartAge = props => {
  const {
    withdrawal = 0,
    specialConditionList,
    insuranceAge,
    mainProduct: { payinPeriodValue },
    onChangeAge,
  } = props;

  const [ageOptions, setAgeOptions] = useState([]);

  useEffect(() => {
    const [option] = specialConditionList;

    const age = Number(insuranceAge);
    const period = Number(payinPeriodValue);
    const minValue = Number(option.minValue);
    const maxValue = Number(option.maxValue);

    const min =
      period === 0
        ? age + minValue
        : Math.max(...[age + minValue, age + period]);
    const max = age + maxValue;

    const options = Array(max - min + 1)
      .fill({})
      .map((item, index) => {
        if (min + index === age) {
          return { label: '31일', value: 0 };
        } else {
          const value = min - age + index;
          return {
            label: `${value}${option.valueName} 후(${min + index}세)`,
            value: value,
          };
        }
      });

    setAgeOptions(options);

    if (!options.map(item => item.value).includes(Number(withdrawal))) {
      onChangeAge(options[0]);
    }
  }, [specialConditionList, insuranceAge, payinPeriodValue]);

  return (
    <div className="cell-col2">
      <div className="cell">
        <div className="tit-area">
          <h2 className="tit-con">노후소득인출 개시 예정</h2>
        </div>
        <SatSelect
          value={withdrawal}
          name={'withdrawal'}
          title="노후소득인출 개시예정"
          width="13rem"
          options={ageOptions}
          onChange={onChangeAge}
        />
      </div>
    </div>
  );
};

export default React.memo(OldWithdrawalStartAge);
